const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  type: 'l=>l.Type',
  description: 'l=>l.Description',
  jsonSnapshot: 'l=>l.JsonSnapshot',
}

export const mapSortLogParam = (key: string) => mapping[key]
